export default {
  compact: true,
  items: [
    {
      label: 'Live GeoGrids',
      href: '/geogrids',
      icon: 'fa-regular fa-border-outer',
      activeUrl: '/geogrids'
    },
    {
      label: 'Scheduled GeoGrids',
      href: '/scheduled_geogrids',
      icon: 'fa-regular fa-clock',
      activeUrl: '/scheduled_geogrids'
    }
  ]
}
